import { useParams } from 'react-router-dom';

import type { SpidrIDParam } from '../constants/routes';

/**
 * Gets the :spidrID path param from the url
 *
 * @returns An object with the spidrID param
 *
 * @example
 * ```tsx
 * const { spidrID } = useSpidrIDParam ();
 * ```
 */
export const useSpidrIDParam = () => {
  const params = useParams<SpidrIDParam>();
  return {
    // (aaho): accepting the risk that this is used in components that are
    // mounted when the spidrID is in the url.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    spidrID: params.spidrID!,
  };
};
